import Box from '@mui/material/Box';
import { useTranslate } from 'react-admin';
import Typography from '@mui/material/Typography';

interface Props {
    imageDataBase64: string;
    name: string;
}

const ShowNoteSignExportItem = ({ imageDataBase64, name }: Props) => {
    const translate = useTranslate();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                '& > *:not(:last-child)': {
                    marginBottom: '8px',
                },
                '& > :last-child': {
                    flexGrow: 1,
                },
            }}
        >
            <Typography>{translate(`notes.signatures_labels.${name}`)}</Typography>

            <Box
                component='img'
                sx={{
                    border: (theme) => `1px solid ${theme.palette.action.disabled}`,
                    borderRadius: 1,
                    maxWidth: '100%',
                    height: '100%',
                }}
                src={imageDataBase64}
            />
        </Box>
    );
};

export default ShowNoteSignExportItem;
